import React, { useState } from 'react'
import './index.scss'
import { Bscroll } from '@/components/bscroll'
import DatePicker from 'react-mobile-datepicker'
import { packDate } from '@/utils/getDate'
import NoEarn from '@/components/noearn'
import { driverMoney } from '@/utils/drivermoney'
import {dayInConmeListApi} from '@/api'
const DEarnShow = (props) => {
  //拿到当日收益详情
  let { incomeDetail, setTodayIncome, setTodayOnline, setIncomeDetail } = props
  let [spanDText, setSpanDText] = useState('今日')
  let [time] = useState(new Date());
  let [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(true);
  }

  const handleCancel = () => {
    setIsOpen(false);
  }
  const handleSelect = (time) => {
    setIsOpen(false);
    setSpanDText(packDate(time))
    //重新请求接口
    driverMoney(dayInConmeListApi, {
      queryDate: packDate(time) + ' 23:59:59'
    })
      .then((d) => {
        if (d.data.data) {
          setTodayIncome(d.data.data.todayIncome)
          setTodayOnline(d.data.data.todayOnline)
          if (d.data.data.incomeDetail && d.data.data.incomeDetail.length > 0) {
            setIncomeDetail(d.data.data.incomeDetail)
          } else {
            setIncomeDetail([])
          }
        }
      })
  }

  const dateConfig = {
    'year': {
      format: 'YYYY' + '年',
      caption: 'Year',
      step: 1,
    },
    'month': {
      format: 'MM' + '月',
      caption: 'Mon',
      step: 1,
    },
    'date': {
      format: 'DD' + '日',
      caption: 'Day',
      step: 1,
    },
  };
  return (
    <div className="d-earn__show">
      <h3 onClick={handleClick}>
        <span>{spanDText}</span>
        <em></em>
      </h3>
      <div className="list-show__box">
        <Bscroll scrollX={false} scrollY={true}>
          <div>
            <div className="d-earn__list">
              {
                incomeDetail.length === 0 ? <NoEarn /> :
                  <ul>
                    {
                      incomeDetail.map((item, index) => (
                        <li key={index}>
                          <span>
                            <em>{item.createTime}</em>
                            <em>{
                              item.type === 1 ? '收到车费' :
                                (item.type === 2 ? '违约金' : (
                                  item.type === 3 ? '附加费' : (
                                    item.type === 4 ? '奖励金额' :'' 
                                  )
                                ))
                            }</em>
                          </span>
                          <span><em>{item.amount / 100}元</em></span>
                        </li>
                      ))
                    }
                  </ul>
              }
            </div>
          </div>
        </Bscroll>
      </div>
      <DatePicker
        value={time}
        isOpen={isOpen}
        onSelect={handleSelect}
        onCancel={handleCancel}
        showHeader={false}
        dateConfig={dateConfig}
        theme="ios"
        confirmText="确定">
      </DatePicker>
    </div >
  )
}
export default DEarnShow